import React from 'react';
import { AppBar, Button, Container, Grid, MenuItem, Select, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
import { useAuth0 } from '@auth0/auth0-react';
import { makeStyles } from '@material-ui/core/styles';
import casegrafWordmark from './images/casegraf-wordmark.svg';

const useStyles = makeStyles({
  appBarStyle: {
    padding: '10px',
    borderBottom: 1,
    borderColor: "primary",
  },
  casegrafLogoStyle: {
    height: '50px',
  },
  buttonStyle: {
    margin: '10px',
    fontWeight: 'bold',
    justify: 'flex-end',
  },
});

export default function HeaderBar() {
  const classes = useStyles();
  const { isAuthenticated, logout, user } = useAuth0();

  return (
    <AppBar position="fixed" color="default" elevation={0} className={classes.appBarStyle}>
      <Container maxWidth='md'>
        <Toolbar>
          <img src={casegrafWordmark} alt="casegraf" className={classes.casegrafLogoStyle} />
          {isAuthenticated && (
            <Grid container justify="flex-end">
              <Typography>{user.name}</Typography>
              <Button
                onClick={() => {console.log('click'); logout()}}
                color='primary'
                variant='contained'
                size='large'
                className={classes.buttonStyle}
              >
                Sign out
              </Button>
            </Grid>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
